import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'

export default function SideMenu() {
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">

        <li className="nav-item">
          <a className="nav-link" href="/dashboard">
            <i className="mdi mdi-grid-large menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="/lead-list">
            <i className="mdi mdi-view-headline  menu-icon"></i>
            <span className="menu-title">Lead List</span>
          </a>
        </li>

        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="collapse" href="#sequencenav" aria-expanded="false" aria-controls="ui-basic">
            <i className="menu-icon mdi mdi-playlist-plus"></i>
            <span className="menu-title">Sequence</span>
            <i className="menu-arrow"></i>
          </a>
          <div className="collapse" id="sequencenav">
            <ul className="nav flex-column sub-menu">
              {/* <li className="nav-item"><a className="nav-link" href="/sequence-list" >All Sequence</a></li> */}
              <li className="nav-item"><a className="nav-link" href="/sequence" >New Sequence</a></li>
              <li className="nav-item"> <a className="nav-link" href="/platform">Define Platform</a></li>
              <li className="nav-item"> <a className="nav-link" href="/selected-lead">Select Lead List</a></li>
            </ul>
          </div>
        </li>
        {/* <li className="nav-item">
            <a className="nav-link" href="/account">
              <i className="mdi mdi-briefcase-check menu-icon"></i>
              <span className="menu-title">Accounts</span>
            </a>
          </li> */}
        <li className="nav-item">
          <a className="nav-link" href="/opportunities">
            <i className="mdi mdi-cash-usd menu-icon"></i>
            <span className="menu-title">Opportunities</span>
          </a>
        </li>

        {/* <li className="nav-item">
          <a className="nav-link" href="/plans">
            <i className="mdi mdi-crown menu-icon"></i>
            <span className="menu-title">Plans</span>
          </a>
        </li> */}

        {/* <li className="nav-item">
          <a className="nav-link" href="/billing">
            <i className="mdi mdi-credit-card menu-icon"></i>
            <span className="menu-title">Billing</span>
          </a>
        </li> */}

        {/* <li className="nav-item">
          <a className="nav-link" href="/invoice">
            <i className="mdi mdi-folder-outline menu-icon"></i>
            <span className="menu-title">Invoice</span>
          </a>
        </li> */}


        {/* <li className="nav-item">
            <a className="nav-link" data-bs-toggle="collapse" href="#myaccountnav" aria-expanded="false" aria-controls="ui-basic">
              <i className="menu-icon mdi mdi-table-edit"></i>
              <span className="menu-title">Settings</span>
              <i className="menu-arrow"></i> 
            </a>
            <div className="collapse" id="myaccountnav">
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <a className="nav-link" href="/user-detail">User Details</a></li>
                <li className="nav-item"> <a className="nav-link comingsoontag">Billing Details</a></li>
                <li className="nav-item"> <a className="nav-link comingsoontag">Subscription Details</a></li>
                <li className="nav-item"> <a className="nav-link comingsoontag">Campaign Details</a></li>
              </ul>
            </div>
          </li> */}

      </ul>
    </nav>
  )
}